export const rootPath = '/instrument-repair-requests';
export const entityPath = '/instrument-repair-requests/:id';

export const addTitle = 'Add Instrument Repair';
export const editTitle = 'Editing Instrument Repair';
export const listTitle = 'Instrument Repair Requests';
export const addButtonText = 'New Repair Request';
export const i18Namespace = 'RepairRequest';
export const defaultSort = '';
